<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormUser" role="form" method="post" autocomplete="off" onSubmit="return false">	

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="username">Usuario</label>
							<input type="text" v-model="objUser.username" class="form-control" id="username" placeholder="Ingresar usuario" :disabled="true" />
							<CValidation v-if="this.errorvalidacion.username" :Mensaje="'*'+errorvalidacion.username[0]"/>
						</div>

					</div>
					
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="password">Contraseña</label>
							<input type="text" v-model="objUser.password" class="form-control" id="password" placeholder="Ingresar password" />
							<CValidation v-if="this.errorvalidacion.password" :Mensaje="'*'+errorvalidacion.password[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="password_confirmation">Confirmar Contraseña</label>
							<input type="text" v-model="objUser.password_confirmation" class="form-control" id="password_confirmation" placeholder="Ingresar password" />
							<CValidation v-if="this.errorvalidacion.password_confirmation" :Mensaje="'*'+errorvalidacion.password_confirmation[0]"/>
						</div>
					</div>


					<div class="form-group row">
						
						<div v-if="origen != 'Clientes'" class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="IdPerfil">Perfil</label>
							<select v-model="objUser.IdPerfil" class="form-control-search form-select" id="IdPerfil">
								<option value="0">Seleccione una opción</option>
								<option v-for="(item, index) in ListaCombo1" :key="index" :value="item.IdPerfil">{{item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdPerfil" :Mensaje="'*'+errorvalidacion.IdPerfil[0]"/>
						</div>

						<div v-if="origen == 'Clientes'" class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 pt-4">
							<div class="form-check form-switch">
								<input v-model="objUser.VerPagos" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault">
								<label class="form-check-label" for="flexSwitchCheckDefault">Ver Pagos</label>
							</div>
						</div>
						<div v-if="origen == 'Clientes'" class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 pt-4">
							<div class="form-check form-switch">
								<input v-model="objUser.VerFacturas" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault">
								<label class="form-check-label" for="flexSwitchCheckDefault">Ver Facturas</label>
							</div>
						</div>

					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import Configs from '../../../helpers/VarConfig';

export default {
    name: 'FormAccesos',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },

            objUser: {
				IdUsuario: 0,
				IdPerfil: 0,
				IdPuesto: 0,
				username: '',
				password: '',
				password_confirmation:'',
				VerPagos: false,
        		VerFacturas: false,
            },

            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			ListaCombo1: [],
			ListaCombo2: [],
			ListaCombo3: [],

			isDeptoCharged:false,
			origen: '',

        }
    },
    methods :
    {
       	async Guardar()
        {	
			let pagos = (this.objUser.VerPagos) ? 'SI' : 'NO';
			let facturas = (this.objUser.VerFacturas) ? 'SI' : 'NO';
			let formData = new FormData();
	
			formData.set('IdUsuario', this.objUser.IdUsuario);
			formData.set('IdPerfil', this.objUser.IdPerfil);
			formData.set('username', this.objUser.username);
			formData.set('password', this.objUser.password);
			formData.set('password_confirmation', this.objUser.password_confirmation);
			formData.set('VerPagos', 	pagos);
			formData.set('VerFacturas', facturas);
			formData.set('Origen', this.origen);
			
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
			
			await this.$http.post('usersaccess', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionUser');
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },

		Recuperar()
        {
            this.$http.get(
                "users/"+this.objUser.IdUsuario

            ).then((res) => {
                this.objUser = res.data.data;

				this.objUser.VerPagos 		=  (this.objUser.VerPagos == 'SI' ) ? true : false;
				this.objUser.VerFacturas 	=  (this.objUser.VerFacturas == 'SI' ) ? true : false;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objUser = {
				IdUsuario: 0,
				IdPerfil: 0,
				IdPuesto: 0,
				username: '',
				password: '',
				password_confirmation:'',
				VerPagos: false,
        		VerFacturas: false,
				
            }
            this.errorvalidacion = [];
        },
		getListPerfiles()
		{
			this.$http.get("perfiles", {
				params:{
					simple: 1,
				}
			}).then((res) => {
				this.ListaCombo1 = res.data.data.perfiles;
			});
		},
		
    },
    created() {

		if(sessionStorage.getItem('origen') != undefined && sessionStorage.getItem('origen') != null ) {
			this.origen = sessionStorage.getItem('origen');
		}

		this.poBtnSave.Toast = 0;
		this.getListPerfiles();

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objUser.IdUsuario = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
